export default __webpack_public_path__ + "media/images/react_icons/paper_write_landlord-1ddbd14943f518c8bd1f8e4879f9bfee.svg";